
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
export default function SubmitPage() {

    const { t } = useTranslation();

  const styles = {

  page: {

    display: "flex",
    justifyContent: "center",
    alignItems: "center",

    padding: "20px",

    background: "#f4f7fb",

    minHeight: "100vh"

  },

  card: {

    // width: "420px",

    width: "500px",

    maxHeight: "90vh",

    overflowY: "auto",

    background: "#ffffff",

    borderRadius: "18px",

    padding: "24px",

    boxShadow:
      "0 10px 30px rgba(0,0,0,0.08)"

  },

  header: {

    marginBottom: "20px"

  },

  heading: {

    margin: 0,

    fontSize: "24px",

    color: "#1e293b"

  },

  subHeading: {

    marginTop: "8px",

    color: "#64748b",

    fontSize: "14px",

    lineHeight: "20px"

  },

  form: {

    display: "flex",

    flexDirection: "column",

    gap: "16px"

  },

  field: {

    display: "flex",

    flexDirection: "column"

  },

  label: {

    fontSize: "14px",

    fontWeight: "600",

    marginBottom: "6px",

    color: "#334155"

  },

  input: {

    padding: "12px",

    border: "1px solid #dbe2ea",

    borderRadius: "10px",

    fontSize: "14px",

    outline: "none"

  },

  select: {

    padding: "12px",

    border: "1px solid #dbe2ea",

    borderRadius: "10px",

    fontSize: "14px",

    background: "#fff",

    outline: "none"

  },

  readonly: {

    padding: "12px",

    border: "1px solid #dbe2ea",

    borderRadius: "10px",

    background: "#f1f5f9",

    fontSize: "14px"

  },

  infoBox: {

    background: "#eff6ff",

    border: "1px solid #bfdbfe",

    borderRadius: "12px",

    padding: "12px"

  },

  infoText: {

    margin: "4px 0",

    fontSize: "13px",

    color: "#1d4ed8"

  },

  button: {

    marginTop: "10px",

    background: "#2563eb",

    color: "#fff",

    border: "none",

    padding: "14px",

    borderRadius: "12px",

    fontSize: "15px",

    fontWeight: "600",

    cursor: "pointer",

    transition: "0.3s"

  }

};

  const [form, setForm] = useState({

    location: "",

    price: "",

    area: "",

    // land_type: "residential",
     type: "residential",

    currency: "INR",

    date: "",

    lat: "",

    lng: ""

  });

  // ======================================
  // AUTO GET USER LOCATION
  // ======================================

  useEffect(() => {

    navigator.geolocation.getCurrentPosition(

      (pos) => {

        setForm((prev) => ({

          ...prev,

          lat: pos.coords.latitude,

          lng: pos.coords.longitude

        }));
      },

      () => {

        console.log(
          "Location permission denied"
        );
      }

    );

  }, []);

  // ======================================
  // HANDLE INPUT
  // ======================================

  const handleChange = (e) => {

    setForm({

      ...form,

      [e.target.name]: e.target.value

    });
  };

  // ======================================
  // SUBMIT
  // ======================================

  const submitLand = async (e) => {

    e.preventDefault();

    try {

      const payload = {
  location: form.location,
  price: Number(form.price),
  area: Number(form.area),
  type: form.type,
  currency: form.currency,
  date: form.date,

  lat: parseFloat(form.lat),
  lng: parseFloat(form.lng)
};

      console.log("SUBMIT PAYLOAD:", payload);

      const res = await fetch(
        "https://land-intelligence-platform-production.up.railway.app/submit",
        {

          method: "POST",

          headers: {
            "Content-Type": "application/json"
          },

          body: JSON.stringify(payload)
        }
      );

      const data = await res.json();

      alert(data.message);

      // RESET FORM

      setForm({

        location: "",

        price: "",

        area: "",

        // land_type: "residential",
          type: "residential",

        currency: "INR",

        date: "",

        lat: form.lat,

        lng: form.lng
      });

    } catch (err) {

      console.log(err);

      alert("Submission failed");
    }
  };

  // ======================================
  // UI
  // ======================================

  return (



<div style={styles.page}>

    <div style={styles.card}>

         {/* HEADER */}
        <div style={styles.header}>

         {/* <h2 style={styles.heading}>
             🌍 Submit Land Details
          </h2> */}

           <h2 style={styles.heading}>
             🌍 {t("submitLandTitle")}
          </h2>

          <p style={styles.subHeading}>
           {t("submitLandDesc")}
           </p>

       </div>


        <form
          onSubmit={submitLand}
          style={styles.form}
        >
<div style={styles.field}>


            <label style={styles.label}>
              {t("location")}
             </label>

          {/* LOCATION */}

          <input
            type="text"
            name="location"
            placeholder={t("location")}
            value={form.location}
            onChange={handleChange}
            required
             style={styles.input}

          />
</div>
          {/* PRICE */}
 <div style={styles.field}>


           <label style={styles.label}>
           {t("price")}
            </label>

          <input
            type="number"
            name="price"
            placeholder={t("price")}
             style={styles.input}
            value={form.price}
            onChange={handleChange}
            required
          />
</div>
          {/* AREA */}

<div style={styles.field}>


           <label style={styles.label}>
           {t("area")}           </label>

          <input
            type="number"
            name="area"
           style={styles.select}

            placeholder={t("area")}
            value={form.area}
            onChange={handleChange}
            required
          />
</div>
          {/* TYPE */}
 <div style={styles.field}>


           <label style={styles.label}>
            {t("landType")}
            </label>

          <select
          style={styles.select}
            name="type"
            value={form.type}
            onChange={handleChange}
          >

            <option value="residential">
              {t("residential")}
            </option>

            <option value="commercial">
              {t("commercial")}
            </option>

            <option value="agriculture">
             {t("agriculture")}
            </option>

          </select>
</div>
          {/* CURRENCY */}
 <div style={styles.field}>


            <label style={styles.label}>
             {t("currency")}
          </label>

          <select
            name="currency"
             style={styles.select}
            value={form.currency}
            onChange={handleChange}
          >

            <option value="INR">
              {t("currencies.INR")}
            </option>

            <option value="USD">
            {t("currencies.USD")}
            </option>

          </select>
</div>
          {/* DATE */}
 <div style={styles.field}>


            <label style={styles.label}>
             {t("submissionDate")}
          </label>

          <input
            type="date"
            name="date"
            value={form.date}
             style={styles.input}

            onChange={handleChange}
            required
          />
          </div>

          {/* LAT */}
 <div style={styles.field}>


             <label style={styles.label}>
            {t("latitude")}
            </label>

          <input
            type="number"
            name="lat"
         
             style={styles.readonly}
            placeholder= {t("latitude")}
            value={form.lat}
               readOnly
          />
          </div>

          {/* LNG */}
<div style={styles.field}>


             <label style={styles.label}>
             {t("longitude")}
            </label>
          <input
            type="number"
            name="lng"
             style={styles.readonly}
            placeholder= {t("longitude")}
            value={form.lng}
            readOnly
          />
</div>

 <div style={styles.infoBox}>


            <p style={styles.infoText}>
              ✅ {t("submittedNote")}
          </p>


             <p style={styles.infoText}>
               ✅ {t("approvedNote")}
            </p>
</div>
          {/* BUTTON */}

          <button
            type="submit"
            style={styles.button}
          >
            {t("submitButton")}
          </button>

        </form>

      </div>

    </div>
  );
}
